import React, { Component, Fragment } from 'react'
import { UsersDropdown } from '../'
import { Button, Icon, Checkbox, Select, Alert, Spin, Dropdown, Menu } from 'antd'
import iconDirectoryDefault from '../../../../resources/images/icons/directory-default.svg'
import iconDirectorySmart from '../../../../resources/images/icons/directory-smart.svg'

import { types } from '../../../../store'
import { roles } from '../../../../constants'

const iconDirectory = {
  DIRECTORY: iconDirectoryDefault,
  SMART_DIRECTORY: iconDirectorySmart
}

export default class ChannelsTable extends Component {
  handleSelectChannel = (id) => {
    const { getChannelById } = this.props

    this.resetCheckAll()

    getChannelById(id)
  }

  onCheckItem = (e, item) => {
    const { table, updateTable } = this.props
    let checkedList = []

    if (table.checkedList.includes(item)) {
      checkedList = [
        ...table.checkedList.filter(i => i.id !== item.id)
      ]
    } else {
      checkedList = [
        ...table.checkedList,
        item
      ]
    }

    updateTable({
      checkedList,
      indeterminate: !!checkedList.length && (checkedList.length < this.getStorageById().length),
      checkAll: checkedList.length === this.getStorageById().length
    })
  }

  onCheckAll = (e) => {
    const { updateTable } = this.props

    updateTable({
      checkedList: e.target.checked ? this.getStorageById() : [],
      indeterminate: false,
      checkAll: e.target.checked
    })
  }

  resetCheckAll () {
    const { updateTable } = this.props

    updateTable({
      checkedList: [],
      indeterminate: false,
      checkAll: false
    })
  }

  getStorageById () {
    const { selectedDirectory, selectedChannel } = this.props

    if (selectedDirectory.id) {
      return [
        ...selectedDirectory.dirs.sort((a, b) => b.timestampModified - a.timestampModified),
        ...selectedDirectory.smartDirs.sort((a, b) => b.timestampAssignment - a.timestampAssignment),
        ...selectedDirectory.files.sort((a, b) => b.timestampAssignment - a.timestampAssignment)
      ]
    }

    return [
      ...selectedChannel.dirs.sort((a, b) => b.timestampModified - a.timestampModified),
      ...selectedChannel.smartDirs.sort((a, b) => b.timestampModified - a.timestampModified),
      ...selectedChannel.files.sort((a, b) => b.timestampAssignment - a.timestampAssignment)
    ]
  }

  onSelectDirectory (item) {
    const { selectDirectory } = this.props

    this.resetCheckAll()
    selectDirectory(item)
  }

  toPreviousStorage = (e) => {
    const { selectedChannel, selectedDirectoryStack, getChannelById, toPreviousPage } = this.props

    const previousId = selectedDirectoryStack[selectedDirectoryStack.length - 2]
    if (previousId === undefined) {
      getChannelById(selectedChannel.id)
    } else {
      toPreviousPage(previousId)
    }
    this.resetCheckAll()
  }

  componentWillUnmount () {
    const { clearSelectedChannel } = this.props

    this.resetCheckAll()
    clearSelectedChannel()
  }

  render () {
    const {
      users,
      groups,
      channels,
      table,
      selectedChannel,
      selectedDirectory,

      addGroups,
      addUsers,
      deleteGroups,
      deleteUsers,

      lock,
      unlock,

      setModal
    } = this.props

    const isSelectedChannel = selectedChannel.id || false
    const isSelectedDirectory = selectedDirectory.id || false

    const assign = [
      ...groups.map(group => { return { id: group.id, name: group.name, type: 'group', key: group.id + '-group' } }),
      ...users
        .filter(user => user.role === roles.USER)
        .map(user => { return { id: user.id, name: user.fullName, type: 'user', key: user.id + '-user' } })
    ]
    const assigned = selectedChannel.id ? [...selectedChannel.groups.map(group => { return { id: group.id, name: group.name, type: 'group', count: group.users.length } }), ...selectedChannel.users.map(user => { return { id: user.id, name: user.fullName, type: 'user', count: 1 } })] : []

    const folderMenu = (
      <Menu>
        <Menu.Item key='1' onClick={() => setModal(types.MODAL_STORAGE_DIRECTORY_CREATE, { status: true, id: selectedDirectory.id ? selectedDirectory.id : selectedChannel.id })}>Add Folder</Menu.Item>
        <Menu.Item key='2' onClick={() => setModal(types.MODAL_STORAGE_DIRECTORY_SMART_CREATE, { status: true, id: selectedDirectory.id ? selectedDirectory.id : selectedChannel.id })}>Add Smart Folder</Menu.Item>
      </Menu>
    )

    return (
      <div className='page-channels__side'>
        <div className='page-channels__top'>
          <div className='page-channels__heading'>Channels</div>
          <div className='page-channels__controls'>
            <Select
              placeholder='Select a Channel'
              dropdownMatchSelectWidth={false}
              dropdownStyle={{
                minWidth: '200px'
              }}
              value={selectedChannel.id}
              style={{ width: 150, marginRight: 15 }}
              onChange={this.handleSelectChannel}
            >
              {channels.list.map((channel, index) => <Select.Option key={index} value={channel.id} >{ channel.name }</Select.Option>) }
            </Select>
            <Button type='indigo' onClick={() => setModal(types.MODAL_CHANNEL_CREATE, true)}>Create Channel</Button>
          </div>
        </div>

        <Spin spinning={channels.isFetchingId}>
          <div className='page-channels__content'>
            <div className='table'>
              <div className='table-header table__header'>
                { selectedChannel.name && this.getStorageById().length > 0
                  ? <div className='table-header__control'>
                    <Checkbox indeterminate={table.indeterminate} onChange={this.onCheckAll} checked={table.checkAll} />
                  </div>
                  : null }
                { selectedChannel.name
                  ? <div className='table-header__control table-header__control_name'>
                    { selectedDirectory.id
                      ? <Button type='dashed' onClick={this.toPreviousStorage}><Icon type='arrow-left' /> { selectedDirectory.name }</Button>
                      : <span>{ selectedChannel.name }</span> }
                  </div>
                  : null }
                { selectedChannel.name
                  ? <UsersDropdown
                    channelId={selectedChannel.id}
                    assign={assign}
                    assigned={assigned}
                    addGroups={addGroups}
                    addUsers={addUsers}
                    deleteGroups={deleteGroups}
                    deleteUsers={deleteUsers} />
                  : null }
              </div>

              <div className='table__content'>
                { selectedChannel.name && this.getStorageById().length >= 0 ? this.getStorageById().map((item, index) =>
                  <div key={index} className='table-item table__item'>
                    <div className='table-item__control'>
                      <Checkbox
                        onChange={(e) => this.onCheckItem(e, item)}
                        checked={table.checkedList.filter(i => i.id === item.id).length} />
                    </div>
                    { item.type === 'DIRECTORY' || item.type === 'SMART_DIRECTORY'
                      ? <div className='table-item__name table-item__name_folder' onClick={() => this.onSelectDirectory(item)}>
                        <img className='table-item__folder' src={iconDirectory[item.type]} alt={item.name} />
                        <span>{ item.name }</span>
                      </div>
                      : null }
                    { item.type === 'FILE'
                      ? <div className='table-item__name'>{ item.name + '.' + item.extension }</div>
                      : null }
                  </div>
                ) : <Alert message='No Channel Selected' type='info' showIcon /> }
                { selectedChannel.name && this.getStorageById().length === 0 ? <Alert message='Assets Not Found' type='warning' showIcon /> : null }
              </div>

              <div className='table-footer table__footer'>

                { isSelectedChannel &&
                <div className='table-footer__control'>
                  <Dropdown overlay={folderMenu} placement='topLeft' trigger={['click']}>
                    <Button type='dashed'>
                      <Icon type='folder-add' /> Add <Icon type='up' />
                    </Button>
                  </Dropdown>
                </div> }

                { isSelectedChannel && !isSelectedDirectory &&
                <Fragment>
                  <div className='table-footer__control'>
                    <Button type='dashed' onClick={() => setModal(types.MODAL_CHANNEL_EDIT, true)}><Icon type='edit' /> Edit Channel</Button>
                  </div>
                  { selectedChannel.locked
                    ? <div className='table-footer__control'>
                      <Button
                        type='dashed'
                        onClick={() => unlock(selectedChannel.id)}
                      >
                        <Icon type='unlock' /> Unlock Channel
                      </Button>
                    </div>
                    : <div className='table-footer__control'>
                      <Button
                        type='dashed'
                        onClick={() => lock(selectedChannel.id)}
                      >
                        <Icon type='lock' /> Lock Channel
                      </Button>
                    </div> }
                </Fragment>
                }

                { isSelectedChannel && isSelectedDirectory && selectedDirectory.type === 'SMART_DIRECTORY' &&
                  <div className='table-footer__control'>
                    <Button type='dashed' onClick={() => setModal(types.MODAL_STORAGE_DIRECTORY_SMART_EDIT, { status: true, id: selectedDirectory.id })}><Icon type='edit' /> Edit Smart Folder</Button>
                  </div>
                }

                { isSelectedChannel && isSelectedDirectory && selectedDirectory.type === 'DIRECTORY' &&
                  <div className='table-footer__control'>
                    <Button type='dashed' onClick={() => setModal(types.MODAL_STORAGE_DIRECTORY_EDIT, { status: true, id: selectedDirectory.id, name: selectedDirectory.name })}><Icon type='edit' /> Edit Folder</Button>
                  </div>
                }

                { table.checkedList.length > 0 && selectedDirectory.type !== 'SMART_DIRECTORY' &&
                  <div className='table-footer__control'>
                    <Button type='dashed' onClick={() => setModal(types.MODAL_STORAGE_DELETE_LINKS, { status: true, id: selectedDirectory.id ? selectedDirectory.id : selectedChannel.id, list: table.checkedList })}><Icon type='delete' /> Delete</Button>
                  </div>
                }
              </div>
            </div>
          </div>
        </Spin>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/views/Channels/components/TableChannels/TableChannels.jsx